import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';

import { CandidatesService } from '@app/portal/candidates/services/candidates.service';
import { PaginationService } from '../services/pagination.service';
import * as PaginationActions from './pagination.actions';

@Injectable()
export class PaginationEffects {

  setMaxPages$ = createEffect(() =>
    this.actions.pipe(
      ofType(PaginationActions.setMaxPages),
      switchMap(values => {
        const maxPagesData: number = values[0].maxPages;

        return of(PaginationActions.setMaxPagesSuccess({ maxPagesData }));
      }),
    )
  );

  setPerPage$ = createEffect(() =>
    this.actions.pipe(
      ofType(PaginationActions.setPerPage),
      switchMap(values => {
        const perPageData = values[0].perPage;

        return of(PaginationActions.setPerPageSuccess({ perPageData }));
      })
    )
  );


  reloadCandidates$ = createEffect(() =>
    this.actions.pipe(
      ofType(
        PaginationActions.setMaxPagesSuccess,
        PaginationActions.setPerPageSuccess
      ),
      map(() => this.candidatesService.getCandidates())
    ),
    { dispatch: false }
  );

  constructor(
    private readonly actions: Actions,
    private readonly candidatesService: CandidatesService,
    private readonly paginationService: PaginationService,
  ) {}

}
